<template>
  <footer>

  </footer>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// index.vue?3d0900ac